import { NgModule, ModuleWithProviders } from '@angular/core';

import { WebSocketService } from './ws.service';
import { WEBSOCKET_CONFIG } from './ws.config';
import { WebSocketConfig } from './ws.interfaces';


@NgModule({
    providers: [
        WebSocketService
    ]
})
export class WebsocketModule {
    public static config(wsConfig: WebSocketConfig): ModuleWithProviders<WebsocketModule> {
        return {
            ngModule: WebsocketModule,
            providers: [{ provide: WEBSOCKET_CONFIG, useValue: wsConfig }]
        };
    }
}
